import { DEFAULT_MAX_MONTHS, DEFAULT_MIN_MONTHS, } from '../../ui-kit/Calculator/calculatorConstants.js';
const DEFAULT_MIN_SUM = 10000;
const DEFAULT_MAX_SUM = 5000000;
export const DEFAULT_CREDIT_CALCULATOR_PARAMS = {
    minSum: DEFAULT_MIN_SUM,
    maxSum: DEFAULT_MAX_SUM,
    minMonths: DEFAULT_MIN_MONTHS,
    maxMonths: DEFAULT_MAX_MONTHS,
    rate: 0,
    isSalaryClient: false,
    isPensionClient: false,
    isStateEmployee: false,
    isInsurance: true,
};
//# sourceMappingURL=defaultCreditCalculatorParams.js.map